import * as React from 'react'
import { useUserPlan } from '../auth/plans/useUserPlan';
import HelpIcon from '@mui/icons-material/Help';
import { Tooltip } from '@mui/material';

type Props = {

}


const RankingSubscriberOnlyBadge: React.FC<Props> = ({ }) => {
  const plan = useUserPlan();
  const isSubscriber = plan?.plan === 'SUBSCRIBED';

  if (isSubscriber) {
    return (
      <Tooltip
      enterTouchDelay={0}
      leaveTouchDelay={5000}
      placement='bottom' title={<div className='p-2 text-base font-normal'>
        You see all available nodes due to your active LnRouter plan. <br/>
        Anonymous users only see nodes that have a LnRouter Plan themselves.
      </div>}>
      <div className='rounded-full uppercase flex items-center bg-viking-1000 px-4 py-1 text-sm text-white ring-2 ring-viking-600'>
        <div>
        All Nodes
        </div>
        <HelpIcon color="inherit" fontSize="inherit" className='ml-1 text-viking-700' />
      </div>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      enterTouchDelay={0}
      leaveTouchDelay={5000}
      placement='bottom' title={<div className='p-2 text-base font-normal '>
        Only subscribers with a routing score 50 or higher are shown. <br/>
        Purchase a LnRouter Plan to view the full list of available nodes.
      </div>}>
      <div className='rounded-full uppercase bg-yellow-400 px-4 py-1 text-sm text-black flex items-center'>
        <div>Subscriber Nodes Only</div>
        <HelpIcon color="inherit" fontSize="inherit" className='ml-1' />
      </div>
    </Tooltip>
  );
}

export default RankingSubscriberOnlyBadge;

